import EZFileLogo from '@/assets/img/ez-file-logo';
import { stytch } from '@/auth/stytch';
import { DASHBOARD_ROUTES, getDashboardURL } from '@/utils/dashboardUrl';
import { Flex, MantineTheme, Text } from '@mantine/core';
import React from 'react';

export interface PartnershipConfig {
  card: {
    bg: string;
  };
  content: {
    headerText: string | null;
    descriptionText: string;
    primaryButtonText: React.ReactNode;
    primaryButtonStyles: Record<string, any>;
    rejectedButtonArrowColor: string;
    bottomButtonText: string;
    ezFileLink: string;
  };
}

export const redirectToEzFileDashboard = () => {
  const tokens = stytch.session.getTokens();

  return `${getDashboardURL()}/${DASHBOARD_ROUTES.sessionAuthenticate}?sessionToken=${
    tokens?.session_token ?? ''
  }&ezFile=true`;
};

interface BuildConfigArgs {
  isPartnershipPreset: boolean;
  partnership?: string;
  firstName: string;
  lastName: string;
  theme: MantineTheme;
}

export const buildLegacyConfig = ({
  isPartnershipPreset,
  partnership,
  firstName,
  lastName,
  theme,
}: BuildConfigArgs): PartnershipConfig => ({
  card: {
    bg: isPartnershipPreset ? 'primary.0' : 'tertiary.0',
  },
  content: {
    headerText: isPartnershipPreset ? null : `EZ-File for ${firstName} ${lastName}`,
    descriptionText: isPartnershipPreset
      ? `With ${
          partnership || 'our partner'
        } you receive free access to EZ File, a 15 minute solution to get you access to financial aid. Fill out the EZ File question form, and we'll take care of the rest!`
      : 'We have a service that applies for financial aid on your behalf. This should significantly decrease or eliminate your medical bill. Click on the link below to get started.',
    primaryButtonText: isPartnershipPreset ? (
      <Flex align="start">
        <Text mr={8}>Continue with</Text>
        <EZFileLogo
          width={87}
          flat
        />
      </Flex>
    ) : (
      'Take me to EZ-File'
    ),
    primaryButtonStyles: isPartnershipPreset
      ? {
          bg: 'tertiary.3',
          styles: (theme: MantineTheme) => ({
            label: { color: theme.colors.neutral[6] },
          }),
          color: 'neutral.6',
        }
      : {},
    rejectedButtonArrowColor: isPartnershipPreset
      ? theme.colors.neutral[6]
      : theme.colors.secondary[0],
    bottomButtonText: isPartnershipPreset
      ? 'No thanks, take me to Resolve Concierge'
      : "I'd rather Resolve work on my behalf",
    ezFileLink: redirectToEzFileDashboard(),
  },
});
